import type { DesignSummary } from '@/types/design'

export const MOCK_DESIGNS: DesignSummary[] = [
  {
    id: 'dsn-001',
    name: 'Projet Hôtel Lumière',
    status: 'completed',
    role: 'accueil',
    environment: 'indoor',
    ai_level: 3,
    budget_band: 'assistant_pro',
    budget_range: '24 000 – 48 000 €',
    missions_count: 4,
    scores: { feasibility: 91, complexity: 52, market_demand: 78, innovation: 65 },
    created_at: '2026-04-10T14:22:00Z',
    updated_at: '2026-04-15T09:10:00Z',
  },
  {
    id: 'dsn-002',
    name: 'Sécurité Entrepôt Nord',
    status: 'exported',
    role: 'securite',
    environment: 'both',
    ai_level: 4,
    budget_band: 'operator_specialist',
    budget_range: '48 000 – 96 000 €',
    missions_count: 5,
    scores: { feasibility: 85, complexity: 74, market_demand: 82, innovation: 70 },
    created_at: '2026-04-02T08:00:00Z',
    updated_at: '2026-04-12T16:45:00Z',
  },
  {
    id: 'dsn-003',
    name: 'Compagnon Senior v1',
    status: 'draft',
    role: 'aide_domicile',
    environment: 'indoor',
    ai_level: 2,
    budget_band: 'companion',
    budget_range: '12 000 – 24 000 €',
    missions_count: 3,
    scores: { feasibility: 95, complexity: 31, market_demand: 90, innovation: 45 },
    created_at: '2026-04-17T11:30:00Z',
    updated_at: '2026-04-17T11:30:00Z',
  },
]
